var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Card as MuiCard, CardContent, Box, Grid, Slide } from '@mui/material';
var Sticky = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: sticky;\n  bottom: 24px;\n  z-index: 11;\n  pointer-events: none;\n"], ["\n  position: sticky;\n  bottom: 24px;\n  z-index: 11;\n  pointer-events: none;\n"])));
var Card = styled(MuiCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  pointer-events: auto;\n\n  &.MuiPaper-root {\n    background-color: #444;\n    color: #ccc;\n  }\n\n  .MuiCardContent-root {\n    padding: 0;\n  }\n"], ["\n  pointer-events: auto;\n\n  &.MuiPaper-root {\n    background-color: #444;\n    color: #ccc;\n  }\n\n  .MuiCardContent-root {\n    padding: 0;\n  }\n"])));
var StickyShoppingCart = function (_a) {
    var children = _a.children, visible = _a.visible;
    return (React.createElement(Sticky, null,
        React.createElement(Slide, { direction: "left", in: visible, timeout: 400, style: {
                display: visible ? 'block' : 'none',
            } },
            React.createElement(Box, { my: 4, role: "article", "aria-label": "\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30AB\u30FC\u30C8" },
                React.createElement(Grid, { container: true, justifyContent: "flex-end" },
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Card, { sx: {
                                maxWidth: '520px',
                                marginLeft: 'auto',
                                boxShadow: function (theme) { return theme.customShadows.z16; },
                            } },
                            React.createElement(CardContent, null, children))))))));
};
export default StickyShoppingCart;
var templateObject_1, templateObject_2;
